import * as React from 'react';
import { styled } from '@mui/system';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, List, ListItem, ListItemButton, Tooltip, Typography, useTheme } from '@mui/material';
import { BracketIcon, HomeIcon, LogoIcon, LogoutIcon, TerminalIcon, XmlIcon } from '../components/Icon';
import { useActionModal } from '../actionModal';

interface NavBarListItemProps {
  name: string;
  href: string;
  currentPath: string;
  icon: JSX.Element;
  marginLeft?: string;
}
const iconStyle = {
  justifyContent: 'center',
  marginBottom: '5px',
  marginTop: '5px'
}

const NavBarListItem = (props: NavBarListItemProps) => {
  const navigate = useNavigate();
  const isActive = props.currentPath==="/"?(props.href==="/scoremodel"): props.currentPath.startsWith(props.href);
  const usePalette = useTheme().palette;
  const handleClick = () => {
    if (!isActive) {
      navigate(props.href);
    }
  };

  return (
    <ListItem sx={{ padding: 0 }}>
      <Tooltip title={props.name} placement='right'>
        <ListItemButton
          selected={isActive}
          onClick={handleClick}
          sx={{
            ...iconStyle,
            fill: isActive ? usePalette.secondary.main : 'none',
            stroke: isActive ? usePalette.primary.main : usePalette.secondary.main,
            color: isActive ? usePalette.primary.main : usePalette.secondary.main, //For XML-icon fill
          }}
        >
          {props.icon}
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
};

const StyledNavBar = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  width: '56px',
  flexShrink: 0
}));

function LogoClickableIcon() {
  const navigate = useNavigate();
  return <LogoIcon style={{ width: '65px', marginTop: '7px', marginBottom: '5px' }}
                   onClick={() => navigate('/scoremodel')} />;
}

export default function NavBar() {
  const intl = useIntl();
  const { pathname } = useLocation();

  const navBarItems = [
    {
      name: intl.formatMessage({ id: 'ScoreModel' }),
      href: '/scoremodel',
      icon: <HomeIcon />
    },
    {
      name: intl.formatMessage({ id: 'Rules' }),
      href: '/rules',
      icon: <BracketIcon />
    },
    {
      name: intl.formatMessage({ id: 'Variables' }),
      href: '/variables',
      icon: <TerminalIcon />
    },
    {
      name: intl.formatMessage({ id: 'Xml' }),
      href: '/xml',
      icon: <XmlIcon />
    }
  ];
  {/*
  Log out functionality not yet implemented.

  const { openActionModal } = useActionModal();
  const usePalette = useTheme().palette;
  function LogoutClickableIcon(){
    return(
      <LogoutIcon onClick={() => openActionModal(
        <Typography fontSize={25}> Do you want to log out? </Typography>,
        <Typography> You will need to log in again to access the solution </Typography>,
        'LOG OUT', 'CANCEL', () => (console.log('add logout functionality'))
      )} style={{
        ...iconStyle,
        marginLeft:'8px',
        fill:'none',
        stroke: usePalette.secondary.main,
      }}></LogoutIcon>
    )
  }*/}

  return (
    <StyledNavBar>
      <List disablePadding>
        <ListItem>
          <LogoClickableIcon></LogoClickableIcon>
        </ListItem>
        {navBarItems.map((item, index) => (
          <NavBarListItem
            key={index}
            name={item.name}
            href={item.href}
            currentPath={pathname}
            icon={item.icon}
          />
        ))}
        {/*
        <ListItem>
          <LogoutClickableIcon></LogoutClickableIcon>
        </ListItem>
        */}
      </List>
    </StyledNavBar>
  );
}
